import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('svg-icon')
export class SvgIcon extends LitElement {

    @property({ type: String })
    name: string = '';

    render() {
        return html`
            <svg aria-hidden="true">
                <use href="#icon--${ this.name }"></use>
            </svg>
        `;
    }

    createRenderRoot() { 
        return this;
    }
}
